import { clearTextSelection, getZIndex } from '@/helpers/dom';

interface DragState {
    draggedEl: HTMLElement | null;
    activePointerId: number | null;
    mouseStartX: number;
    mouseStartY: number;
    startLeft: number;
    startTop: number;
    prevTransition: string;
    prevPosition: string;
    prevMargin: string;
}

const d: DragState = {
    draggedEl: null,
    activePointerId: null,
    mouseStartX: 0,
    mouseStartY: 0,
    startLeft: 0,
    startTop: 0,
    prevTransition: '',
    prevPosition: '',
    prevMargin: '',
};

let removeMousemove: VoidFunction | null = null;
let removeMouseup: VoidFunction | null = null;

function onBetPopupPointerMove(e: PointerEvent) {
    console.log('move');

    if (d.activePointerId !== e.pointerId) return;

    if (!d.draggedEl) return;

    clearTextSelection();

    const rect = d.draggedEl.getBoundingClientRect();

    const newLeft = d.startLeft + (e.clientX - d.mouseStartX);
    const newTop = d.startTop + (e.clientY - d.mouseStartY);

    const clampedLeft = Math.min(Math.max(newLeft, 0), window.innerWidth - rect.width);
    const clampedTop = Math.min(Math.max(newTop, 0), window.innerHeight - rect.height);

    d.draggedEl.style.left = `${clampedLeft}px`;
    d.draggedEl.style.top = `${clampedTop}px`;
}

function onBetPopupPointerUp() {
    if (!d.draggedEl) return;

    d.draggedEl.style.transition = d.prevTransition;
    //d.draggedEl.style.position = d.prevPosition;
    //d.draggedEl.style.margin = d.prevMargin;
    d.draggedEl = null;
    d.activePointerId = null;

    if (removeMousemove) removeMousemove();
    if (removeMouseup) removeMouseup();
}

export function onBetPopupPointerDown(e: PointerEvent) {
    let indexHighest = 0;
    let indexHighestEvent = 0;

    clearTextSelection();

    if (!(e.target instanceof Element)) return;

    const overlayDialog = e.target.closest<HTMLDivElement>('.v-dialog.v-overlay--active');
    if (!overlayDialog) return;

    //if it is not left button
    if (e.button !== 0 && e.pointerType === 'mouse') return;

    const isHeader = e.target.classList.contains('popup-header') || e.target.parentElement?.classList.contains('popup-header');
    if (!isHeader) return;

    // element which can be used to move element
    document.querySelectorAll<HTMLDivElement>('.v-dialog.v-overlay--active').forEach((dialog) => {
        const zIndex = parseInt(dialog.style.zIndex || '0', 10);
        const isEventDialog = dialog.firstElementChild?.classList.contains('event-bet-dialog');

        if (isEventDialog) {
            indexHighestEvent = Math.max(indexHighestEvent, zIndex);
        } else {
            indexHighest = Math.max(indexHighest, zIndex);
        }
    });

    const currentZ = getZIndex(overlayDialog);
    const isEventDialog = overlayDialog.firstElementChild?.classList.contains('event-bet-dialog') === true;

    const targetBase = isEventDialog ? indexHighestEvent : indexHighest;
    const targetZ = targetBase + 1;

    if (currentZ < targetZ) {
        overlayDialog.style.zIndex = String(targetZ);
    }

    const dialogContent = overlayDialog.firstElementChild as HTMLElement | null;
    if (!dialogContent) return;

    d.draggedEl = dialogContent; // element which should be moved
    d.activePointerId = e.pointerId;

    d.mouseStartX = e.clientX;
    d.mouseStartY = e.clientY;

    const rect = dialogContent.getBoundingClientRect();
    d.startLeft = rect.left;
    d.startTop = rect.top;

    dialogContent.style.position = 'fixed';
    dialogContent.style.margin = '0';

    d.prevTransition = dialogContent.style.transition;
    dialogContent.style.transition = 'none';

    window.addEventListener('pointermove', onBetPopupPointerMove, { passive: true });
    window.addEventListener('pointerup', onBetPopupPointerUp, { passive: true });
    window.addEventListener('pointercancel', onBetPopupPointerUp, { passive: true });
    removeMousemove = () => window.removeEventListener('pointermove', onBetPopupPointerMove);
    removeMouseup = () => {
        window.removeEventListener('pointerup', onBetPopupPointerUp);
        window.removeEventListener('pointercancel', onBetPopupPointerUp);
    };
}
